import React, { FC } from "react";

import classNames from "classnames";
import dayjs from "dayjs";

import { DateFormat, formatStringToDateFormat } from "@util/index";

import styles from "./index.module.scss";

interface SubmissionInfoProps {
  resaleCount?: number;
  date?: string;
}

export const SubmissionInfo: FC<SubmissionInfoProps> = ({ resaleCount, date }) => {
  if (!date) {
    return <></>;
  }

  const isValidDate = dayjs(date).isValid();
  const displayDate = isValidDate ? formatStringToDateFormat(date, DateFormat.DD_MM_YYYY_SLASH) : date;
  return (
    <div className={classNames(styles["header-submission-info"], "b4")}>
      {resaleCount && <span>{resaleCount} reports | </span>}
      <span>{displayDate}</span>
    </div>
  );
};
